<div class="header-bar">
  <h1>{{ agreementTypeHeader }}</h1>
</div>
<div class="" style="position: relative">
  <div class="agreement">
    <form [formGroup]="agreementForm" *ngIf="isLoaded; else loading" autocomplete="off">
      <p-tabView #tabviewMain class="tab-padding">
        <p-tabPanel header="Agreement">
          <div *ngIf="access.servicesProvided" class="ui-grid-row">
            <div class="ui-g-12" style="overflow-x: auto">
              <h2 class="sub-header-bar">Services Provided</h2>
              <div *ngIf="!access.isVMEAdmin" style="margin-bottom: 5px">
                Tick all capabilities within your organisation (e.g. if you have one plated driver,
                please check this box)
              </div>

              <div
                *ngIf="
                  reqAgreementType == agreementType.GenericSupplierTerms ||
                  (reqAgreementType == agreementType.GenericSupplier && !access.isVMEAdmin)
                "
                class="ui-grid-row"
                style="margin-top: 15px; margin-bottom: 10px"
              >
                <div style="font-weight: bold; margin-bottom: 5px">Please note</div>
                <div style="font-size: 0.8rem">
                  {{ serviceDefaultDesc }}
                </div>
                <div style="font-size: 0.8rem">
                  If you have additional driving capabilities, please send an email to
                  network@engineius.co.uk with supporting documents to get your Generic Agreement
                  Capabilities expanded (this will increase your visibility of available jobs)
                </div>

                <div *ngIf="access.servicesProvided == this.AccessReadOnly" class="permission-note">
                  <b>Note:</b> Only a member of the Network Assurance Team can change the service
                  statuses
                </div>
              </div>

              <p-accordion [multiple]="true" [class.rate-card-accordion]="true">
                <p-accordionTab header="Driven" [selected]="true">
                  <p-table
                    selectionMode="single"
                    [value]="srvGridData[0]"
                    [lazy]="false"
                    [paginator]="false"
                    rowHover="false"
                    resizableColumns="true"
                    [class.no-zebra-shading]="true"
                    [responsive]="true"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Service</th>
                        <th>Max Weight</th>
                        <th>Service Offered</th>
                        <th
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          Fix Price
                        </th>
                        <ng-template
                          [ngIf]="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5 ||
                              reqAgreementType == 6)
                          "
                        >
                          <th *ngFor="let f of premiumFlagsList" pTooltip="Apply {{ f.label }}?">
                            Apply {{ f.label }}
                          </th>
                        </ng-template>
                        <th
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          Urgency Hours
                        </th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-data>
                      <tr>
                        <td>
                          <span>{{
                            data.serviceTypeName + (data.notes ? ' (' + data.notes + ')' : '')
                          }}</span>
                        </td>
                        <td>
                          <span>{{
                            (data.minWeight > 0 ? data.minWeight + 't' : '') +
                              (data.maxWeight > 0
                                ? data.minWeight > 0
                                  ? ' - ' + data.maxWeight + 't'
                                  : 'Less than ' + data.maxWeight + 't'
                                : data.minWeight > 0
                                ? '+'
                                : 'All')
                          }}</span>
                        </td>
                        <td style="text-align: center">
                          <p-checkbox
                            [disabled]="serviceNotAccessible()"
                            name="isServiceOffered"
                            [ngModel]="data.isServiceOffered"
                            [ngModelOptions]="{ standalone: true }"
                            binary="true"
                            (onChange)="changeIsServiceOffered($event, data)"
                          ></p-checkbox>
                        </td>
                        <td
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                          style="text-align: center"
                        >
                          <p-checkbox
                            [disabled]="serviceNotAccessible()"
                            name="isFixPrice"
                            [ngModel]="data.isFixPrice"
                            [ngModelOptions]="{ standalone: true }"
                            binary="true"
                            (onChange)="changeIsFixPrice($event, data)"
                          ></p-checkbox>
                        </td>

                        <ng-template
                          [ngIf]="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5 ||
                              reqAgreementType == 6)
                          "
                        >
                          <td *ngFor="let f of premiumFlagsList" style="text-align: center">
                            <p-checkbox
                              [disabled]="serviceNotAccessible()"
                              name="applyPremium"
                              [ngModel]="data.applyPremium | hasFlags : f.value"
                              [ngModelOptions]="{ standalone: true }"
                              binary="true"
                              (onChange)="changeApplyPremium($event, data, f.value)"
                            ></p-checkbox>
                          </td>
                        </ng-template>

                        <td
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          <input
                            type="number"
                            min="1"
                            max="168"
                            pInputText
                            [disabled]="serviceNotAccessible()"
                            name="urgencyHours"
                            [ngModel]="data.urgencyHours"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="changeUrgencyHours($event, data)"
                          />
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-accordionTab>

                <p-accordionTab
                  header="Transported"
                  [selected]="isTransporter()"
                  [style]="{ 'margin-top': '20px' }"
                >
                  <p-table
                    selectionMode="single"
                    [value]="srvGridData[1]"
                    [lazy]="false"
                    [paginator]="false"
                    rowHover="false"
                    resizableColumns="true"
                    [class.no-zebra-shading]="true"
                    [responsive]="true"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Service</th>
                        <th>Max Weight</th>
                        <th>Service Offered</th>
                        <th
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          Fix Price
                        </th>
                        <ng-template
                          [ngIf]="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5 ||
                              reqAgreementType == 6)
                          "
                        >
                          <th *ngFor="let f of premiumFlagsList" pTooltip="Apply {{ f.label }}">
                            Apply {{ f.label }}
                          </th>
                        </ng-template>
                        <th
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          Urgency Hours
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                      <tr>
                        <td>
                          <span>{{
                            item.serviceTypeName + (item.notes ? ' (' + item.notes + ')' : '')
                          }}</span>
                        </td>
                        <td>
                          <span>
                            {{
                              (item.minWeight > 0 ? item.minWeight + 't' : '') +
                                (item.maxWeight > 0
                                  ? item.minWeight > 0
                                    ? ' - ' + item.maxWeight + 't'
                                    : 'Less than ' + item.maxWeight + 't'
                                  : item.minWeight > 0
                                  ? '+'
                                  : 'All')
                            }}
                          </span>
                        </td>
                        <td style="text-align: center">
                          <p-checkbox
                            [disabled]="serviceNotAccessible()"
                            name="isServiceOffered"
                            [ngModel]="item.isServiceOffered"
                            [ngModelOptions]="{ standalone: true }"
                            binary="true"
                            (onChange)="changeIsServiceOffered($event, item)"
                          ></p-checkbox>
                        </td>
                        <td
                          style="text-align: center"
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          <p-checkbox
                            [disabled]="serviceNotAccessible()"
                            name="isFixPrice"
                            [ngModel]="item.isFixPrice"
                            [ngModelOptions]="{ standalone: true }"
                            binary="true"
                            (onChange)="changeIsFixPrice($event, item)"
                          ></p-checkbox>
                        </td>
                        <ng-template
                          [ngIf]="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5 ||
                              reqAgreementType == 6)
                          "
                        >
                          <td *ngFor="let f of premiumFlagsList" style="text-align: center">
                            <p-checkbox
                              [disabled]="serviceNotAccessible()"
                              name="applyPremium"
                              [ngModel]="item.applyPremium | hasFlags : f.value"
                              [ngModelOptions]="{ standalone: true }"
                              binary="true"
                              (onChange)="changeApplyPremium($event, item, f.value)"
                            ></p-checkbox>
                          </td>
                        </ng-template>
                        <td
                          style="text-align: center"
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          <input
                            type="number"
                            min="1"
                            max="168"
                            [disabled]="serviceNotAccessible()"
                            pInputText
                            name="urgencyHours"
                            [ngModel]="item.urgencyHours"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="changeUrgencyHours($event, item)"
                          />
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-accordionTab>

                <p-accordionTab
                  header="Recovery"
                  [selected]="isRecoverer()"
                  [style]="{ 'margin-top': '20px' }"
                >
                  <p-table
                    selectionMode="single"
                    [value]="srvGridData[2]"
                    [lazy]="false"
                    [paginator]="false"
                    rowHover="false"
                    resizableColumns="true"
                    [class.no-zebra-shading]="true"
                    [responsive]="true"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Service</th>
                        <th>Vehicle Classification</th>
                        <th>Service Offered</th>
                        <th
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          Fix Price
                        </th>
                        <ng-template
                          [ngIf]="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5 ||
                              reqAgreementType == 6)
                          "
                        >
                          <th *ngFor="let f of premiumFlagsList" pTooltip="Apply {{ f.label }}">
                            Apply {{ f.label }}
                          </th>
                        </ng-template>
                        <th
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          Urgency Hours
                        </th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-data>
                      <tr>
                        <td>
                          <span>{{
                            data.serviceTypeName + (data.notes ? ' (' + data.notes + ')' : '')
                          }}</span>
                        </td>
                        <td>
                          <span>
                            {{
                              (data.minWeight > 0 ? data.minWeight + 't' : '') +
                                (data.maxWeight > 0
                                  ? data.minWeight > 0
                                    ? ' - ' + data.maxWeight + 't'
                                    : 'Less than ' + data.maxWeight + 't'
                                  : data.minWeight > 0
                                  ? '+'
                                  : 'All')
                            }}
                          </span>
                        </td>
                        <td style="text-align: center">
                          <p-checkbox
                            [disabled]="serviceNotAccessible()"
                            name="isServiceOffered"
                            [ngModel]="data.isServiceOffered"
                            [ngModelOptions]="{ standalone: true }"
                            binary="true"
                            (onChange)="changeIsServiceOffered($event, data)"
                          ></p-checkbox>
                        </td>
                        <td
                          style="text-align: center"
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          <p-checkbox
                            [disabled]="serviceNotAccessible()"
                            name="isServiceOffered"
                            [ngModel]="data.isFixPrice"
                            [ngModelOptions]="{ standalone: true }"
                            binary="true"
                            (onChange)="changeIsFixPrice($event, data)"
                          ></p-checkbox>
                        </td>
                        <ng-template
                          [ngIf]="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5 ||
                              reqAgreementType == 6)
                          "
                        >
                          <td *ngFor="let f of premiumFlagsList" style="text-align: center">
                            <p-checkbox
                              [disabled]="serviceNotAccessible()"
                              name="applyPremium"
                              [ngModel]="data.applyPremium | hasFlags : f.value"
                              [ngModelOptions]="{ standalone: true }"
                              binary="true"
                              (onChange)="changeApplyPremium($event, data, f.value)"
                            ></p-checkbox>
                          </td>
                        </ng-template>
                        <td
                          style="text-align: center"
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          <input
                            type="number"
                            min="1"
                            max="168"
                            [disabled]="serviceNotAccessible()"
                            pInputText
                            name="urgencyHours"
                            [ngModel]="data.urgencyHours"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="changeUrgencyHours($event, data)"
                          />
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-accordionTab>

                <p-accordionTab header="Inspection" [style]="{ 'margin-top': '20px' }">
                  <p-table
                    selectionMode="single"
                    [value]="srvGridData[3]"
                    [lazy]="false"
                    [paginator]="false"
                    rowHover="false"
                    resizableColumns="true"
                    [class.no-zebra-shading]="true"
                    [responsive]="true"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Service</th>
                        <th>Vehicle Classification</th>
                        <th>Service Offered</th>
                        <th
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          Fix Price
                        </th>
                        <ng-template
                          [ngIf]="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5 ||
                              reqAgreementType == 6)
                          "
                        >
                          <th *ngFor="let f of premiumFlagsList" pTooltip="Apply {{ f.label }}">
                            Apply {{ f.label }}
                          </th>
                        </ng-template>
                        <th
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          Urgency Hours
                        </th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-data>
                      <tr>
                        <td>
                          <span>{{
                            data.serviceTypeName + (data.notes ? ' (' + data.notes + ')' : '')
                          }}</span>
                        </td>
                        <td>
                          <span>
                            {{
                              (data.minWeight > 0 ? data.minWeight + 't' : '') +
                                (data.maxWeight > 0
                                  ? data.minWeight > 0
                                    ? ' - ' + data.maxWeight + 't'
                                    : 'Less than ' + data.maxWeight + 't'
                                  : data.minWeight > 0
                                  ? '+'
                                  : 'All')
                            }}
                          </span>
                        </td>
                        <td style="text-align: center">
                          <p-checkbox
                            [disabled]="serviceNotAccessible()"
                            name="isServiceOffered"
                            [ngModel]="data.isServiceOffered"
                            [ngModelOptions]="{ standalone: true }"
                            binary="true"
                            (onChange)="changeIsServiceOffered($event, data)"
                          ></p-checkbox>
                        </td>
                        <td
                          style="text-align: center"
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          <p-checkbox
                            [disabled]="serviceNotAccessible()"
                            name="isServiceOffered"
                            [ngModel]="data.isFixPrice"
                            [ngModelOptions]="{ standalone: true }"
                            binary="true"
                            (onChange)="changeIsFixPrice($event, data)"
                          ></p-checkbox>
                        </td>
                        <ng-template
                          [ngIf]="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5 ||
                              reqAgreementType == 6)
                          "
                        >
                          <td *ngFor="let f of premiumFlagsList" style="text-align: center">
                            <p-checkbox
                              [disabled]="serviceNotAccessible()"
                              name="applyPremium"
                              [ngModel]="data.applyPremium | hasFlags : f.value"
                              [ngModelOptions]="{ standalone: true }"
                              binary="true"
                              (onChange)="changeApplyPremium($event, data, f.value)"
                            ></p-checkbox>
                          </td>
                        </ng-template>
                        <td
                          style="text-align: center"
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          <input
                            type="number"
                            min="1"
                            max="168"
                            [disabled]="serviceNotAccessible()"
                            pInputText
                            name="urgencyHours"
                            [ngModel]="data.urgencyHours"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="changeUrgencyHours($event, data)"
                          />
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-accordionTab>
                <p-accordionTab header="Inspect & Collect" [style]="{ 'margin-top': '20px' }">
                  <p-table
                    selectionMode="single"
                    [value]="srvGridData[4]"
                    [lazy]="false"
                    [paginator]="false"
                    rowHover="false"
                    resizableColumns="true"
                    [class.no-zebra-shading]="true"
                    [responsive]="true"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Service</th>
                        <th>Vehicle Classification</th>
                        <th>Service Offered</th>
                        <th
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          Fix Price
                        </th>
                        <ng-template
                          [ngIf]="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5 ||
                              reqAgreementType == 6)
                          "
                        >
                          <th *ngFor="let f of premiumFlagsList" pTooltip="Apply {{ f.label }}">
                            Apply {{ f.label }}
                          </th>
                        </ng-template>
                        <th
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          Urgency Hours
                        </th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-data>
                      <tr>
                        <td>
                          <span>{{
                            data.serviceTypeName + (data.notes ? ' (' + data.notes + ')' : '')
                          }}</span>
                        </td>
                        <td>
                          <span>
                            {{
                              (data.minWeight > 0 ? data.minWeight + 't' : '') +
                                (data.maxWeight > 0
                                  ? data.minWeight > 0
                                    ? ' - ' + data.maxWeight + 't'
                                    : 'Less than ' + data.maxWeight + 't'
                                  : data.minWeight > 0
                                  ? '+'
                                  : 'All')
                            }}
                          </span>
                        </td>
                        <td style="text-align: center">
                          <p-checkbox
                            [disabled]="serviceNotAccessible()"
                            name="isServiceOffered"
                            [ngModel]="data.isServiceOffered"
                            [ngModelOptions]="{ standalone: true }"
                            binary="true"
                            (onChange)="changeIsServiceOffered($event, data)"
                          ></p-checkbox>
                        </td>
                        <td
                          style="text-align: center"
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          <p-checkbox
                            [disabled]="serviceNotAccessible()"
                            name="isServiceOffered"
                            [ngModel]="data.isFixPrice"
                            [ngModelOptions]="{ standalone: true }"
                            binary="true"
                            (onChange)="changeIsFixPrice($event, data)"
                          ></p-checkbox>
                        </td>
                        <ng-template
                          [ngIf]="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5 ||
                              reqAgreementType == 6)
                          "
                        >
                          <td *ngFor="let f of premiumFlagsList" style="text-align: center">
                            <p-checkbox
                              [disabled]="serviceNotAccessible()"
                              name="applyPremium"
                              [ngModel]="data.applyPremium | hasFlags : f.value"
                              [ngModelOptions]="{ standalone: true }"
                              binary="true"
                              (onChange)="changeApplyPremium($event, data, f.value)"
                            ></p-checkbox>
                          </td>
                        </ng-template>
                        <td
                          style="text-align: center"
                          *ngIf="
                            access.isVMEAdmin &&
                            (reqAgreementType == 1 ||
                              reqAgreementType == 2 ||
                              reqAgreementType == 3 ||
                              reqAgreementType == 4 ||
                              reqAgreementType == 5)
                          "
                        >
                          <input
                            type="number"
                            min="1"
                            max="168"
                            [disabled]="serviceNotAccessible()"
                            pInputText
                            name="urgencyHours"
                            [ngModel]="data.urgencyHours"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="changeUrgencyHours($event, data)"
                          />
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </p-accordionTab>
              </p-accordion>
            </div>
          </div>
          <!--
          <div
            *ngIf="
              access.postcodes &&
              (reqAgreementType == agreementType.BespokeSupplier ||
                reqAgreementType == agreementType.BespokeCustomer)
            "
            class="ui-grid-row"
          >
            <div class="ui-g-12">
              <h2 style="display: inline-block">Geography Covered</h2>
              <input
                [value]="
                  access.postcodes == AccessReadOnly ? 'View postcodes' : 'Choose postcodes'
                "
                type="button"
                pButton
                (click)="choosePostcodes()"
                style="margin-left: 10px"
              />
            </div>
          </div>-->

          <!-- No need to show this to supplier -->
          <div *ngIf="access.times && access.isVMEAdmin" formArrayName="times">
            <div class="ui-g">
              <div class="ui-g-12">
                <h2 class="sub-header-bar mb-1">Times</h2>
              </div>

              <div class="ui-g-12">
                <div class="card">
                  <div class="ui-g">
                    <div class="ui-g-2 ui-sm-6"><label>Weekday Opening Time</label></div>
                    <div class="ui-g-2 ui-sm-6">
                      <p-calendar
                        [disabled]="access.times == AccessReadOnly"
                        [class.access-disabled]="access.times == AccessReadOnly"
                        formControlName="weekOfficeOpeningTime"
                        tabindex="21"
                        [timeOnly]="true"
                      ></p-calendar>
                      <div
                        *ngIf="
                          officeHoursService.inputErrorToShow(agreement.times.weekOfficeOpeningTime)
                        "
                        class="ui-message ui-messages-error ui-corner-all"
                      >
                        {{
                          officeHoursService.inputErrorToShow(agreement.times.weekOfficeOpeningTime)
                        }}
                      </div>
                    </div>

                    <div class="ui-g-2 ui-sm-6"><label>Weekday Closing Time</label></div>
                    <div class="ui-g-2 ui-sm-6">
                      <p-calendar
                        [disabled]="access.times == AccessReadOnly"
                        formControlName="weekOfficeClosingTime"
                        tabindex="22"
                        [class.access-disabled]="access.times == AccessReadOnly"
                        [timeOnly]="true"
                      ></p-calendar>
                      <div
                        *ngIf="
                          officeHoursService.inputErrorToShow(agreement.times.weekOfficeClosingTime)
                        "
                        class="ui-message ui-messages-error ui-corner-all"
                      >
                        {{
                          officeHoursService.inputErrorToShow(agreement.times.weekOfficeClosingTime)
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="ui-g">
                    <div class="ui-g-2 ui-sm-6"><label>Open Saturday</label></div>
                    <div class="ui-g-2 ui-sm-6">
                      <p-checkbox
                        [disabled]="access.times == AccessReadOnly"
                        name="openOnSaturday"
                        binary="true"
                        formControlName="openOnSaturday"
                      ></p-checkbox>
                    </div>

                    <div class="ui-g-2 ui-sm-6"><label for="">Saturday Opening Time</label></div>
                    <div class="ui-g-2 ui-sm-6">
                      <p-calendar
                        [disabled]="
                          access.times == AccessReadOnly || !agreement.times.openOnSaturday.value
                        "
                        [class.access-disabled]="access.times == AccessReadOnly"
                        tabindex="23"
                        formControlName="saturdayOpeningTime"
                        [timeOnly]="true"
                      >
                      </p-calendar>
                      <div
                        *ngIf="
                          officeHoursService.inputErrorToShow(agreement.times.saturdayOpeningTime)
                        "
                        class="ui-message ui-messages-error ui-corner-all"
                      >
                        {{
                          officeHoursService.inputErrorToShow(agreement.times.saturdayOpeningTime)
                        }}
                      </div>
                    </div>

                    <div class="ui-g-2 ui-sm-6"><label>Saturday Closing Time</label></div>
                    <div class="ui-g-2 ui-sm-6">
                      <p-calendar
                        [disabled]="
                          access.times == AccessReadOnly || !agreement.times.openOnSaturday.value
                        "
                        tabindex="24"
                        [class.access-disabled]="access.times == AccessReadOnly"
                        formControlName="saturdayClosingTime"
                        [timeOnly]="true"
                      ></p-calendar>
                      <div
                        *ngIf="
                          officeHoursService.inputErrorToShow(agreement.times.saturdayClosingTime)
                        "
                        class="ui-message ui-messages-error ui-corner-all"
                      >
                        {{
                          officeHoursService.inputErrorToShow(agreement.times.saturdayClosingTime)
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="ui-g">
                    <div class="ui-g-2 ui-sm-6"><label>Open Sunday</label></div>
                    <div class="ui-g-2 ui-sm-6">
                      <p-checkbox
                        [disabled]="access.times == AccessReadOnly"
                        name="openOnSunday"
                        binary="true"
                        formControlName="openOnSunday"
                      ></p-checkbox>
                    </div>
                    <div class="ui-g-2 ui-sm-6"><label for="">Sunday Opening Time</label></div>
                    <div class="ui-g-2 ui-sm-6">
                      <p-calendar
                        [disabled]="
                          access.times == AccessReadOnly || !agreement.times.openOnSunday.value
                        "
                        tabindex="25"
                        [class.access-disabled]="access.times == AccessReadOnly"
                        formControlName="sundayOpeningTime"
                        [timeOnly]="true"
                      >
                      </p-calendar>
                      <div
                        *ngIf="
                          officeHoursService.inputErrorToShow(agreement.times.sundayOpeningTime)
                        "
                        class="ui-message ui-messages-error ui-corner-all"
                      >
                        {{ officeHoursService.inputErrorToShow(agreement.times.sundayOpeningTime) }}
                      </div>
                    </div>

                    <div class="ui-g-2 ui-sm-6"><label>Sunday Closing Time</label></div>
                    <div class="ui-g-2 ui-sm-6">
                      <p-calendar
                        [disabled]="
                          access.times == AccessReadOnly || !agreement.times.openOnSunday.value
                        "
                        tabindex="26"
                        [class.access-disabled]="access.times == AccessReadOnly"
                        formControlName="sundayClosingTime"
                        [timeOnly]="true"
                      ></p-calendar>
                      <div
                        *ngIf="
                          officeHoursService.inputErrorToShow(agreement.times.sundayClosingTime)
                        "
                        class="ui-message ui-messages-error ui-corner-all"
                      >
                        {{ officeHoursService.inputErrorToShow(agreement.times.sundayClosingTime) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- No need to show this to supplier -->
          <div formArrayName="details" *ngIf="access.isVMEAdmin" class="ui-g">
            <div class="ui-g-12">
              <h2 class="sub-header-bar mb-1">Service Levels</h2>
            </div>
            <div *ngIf="access.serviceLevels" style="" class="ui-g-12">
              <div class="card">
                <div class="ui-grid-row">
                  <div class="ui-g-6 ui-sm-12">
                    <div class="ui-grid-col-4">
                      <label>Response Time (mins)</label>
                    </div>
                    <div class="ui-grid-col-8">
                      <input
                        [readonly]="access.serviceLevels == AccessReadOnly"
                        pInputText
                        id="serviceResponseTime"
                        formControlName="serviceResponseTime"
                        maxlength="3"
                        (keydown)="inputHelper.allowNumberInputKey($event, false)"
                        (keyup)="inputHelper.fixDigits($event.target)"
                      />
                    </div>
                  </div>
                </div>
                <div class="ui-grid-row">
                  <div class="ui-g-6 ui-sm-12">
                    <div class="ui-grid-col-4">
                      <label>% Jobs Accepted</label>
                    </div>
                    <div class="ui-grid-col-8">
                      <input
                        [readonly]="access.serviceLevels == AccessReadOnly"
                        pInputText
                        id="serviceJobsAccepted"
                        formControlName="serviceJobsAccepted"
                        maxlength="2"
                        (keydown)="inputHelper.allowNumberInputKey($event, false)"
                        (keyup)="inputHelper.fixDigits($event.target)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="access.pricingGroup1 || access.pricingGroup2 || access.pricingGroup3"
              style=""
              class="ui-g"
            >
              <div class="ui-g-12">
                <h2 class="sub-header-bar mb-1">Pricing</h2>
              </div>

              <div class="ui-g-12">
                <div class="card">
                  <div class="ui-grid-row">
                    <div class="ui-md-5 ui-g-12">
                      <div *ngIf="access.pricingGroup1" class="ui-grid-row">
                        <div class="ui-g-12 ui-sm-12">
                          <div class="ui-grid-col-8">
                            <label>Cancellation Fee (£)</label>
                          </div>
                          <div class="ui-grid-col-4">
                            <input
                              [readonly]="access.pricingGroup1 == AccessReadOnly"
                              pInputText
                              id="pricingCancellationFee"
                              formControlName="pricingCancellationFee"
                              maxlength="6"
                              (keydown)="inputHelper.allowNumberInputKey($event)"
                              (keyup)="inputHelper.fixDigits($event.target)"
                            />
                          </div>
                        </div>
                      </div>
                      <div *ngIf="access.pricingGroup1" class="ui-grid-row">
                        <div class="ui-g-12 ui-sm-12">
                          <div class="ui-grid-col-8">
                            <label>Aborted Job Fee (£)</label>
                          </div>
                          <div class="ui-grid-col-4">
                            <input
                              [readonly]="access.pricingGroup1 == AccessReadOnly"
                              pInputText
                              id="pricingAbortedJobFee"
                              formControlName="pricingAbortedJobFee"
                              maxlength="6"
                              (keydown)="inputHelper.allowNumberInputKey($event)"
                              (keyup)="inputHelper.fixDigits($event.target)"
                            />
                          </div>
                        </div>
                      </div>
                      <div *ngIf="access.pricingGroup2" class="ui-grid-row">
                        <div class="ui-g-12 ui-sm-12">
                          <div class="ui-grid-col-8">
                            <label>Bank Holiday Fee (£)</label>
                          </div>
                          <div class="ui-grid-col-4">
                            <input
                              [readonly]="access.pricingGroup2 == AccessReadOnly"
                              pInputText
                              id="pricingBankHolidayFee"
                              formControlName="pricingBankHolidayFee"
                              maxlength="6"
                              (keydown)="inputHelper.allowNumberInputKey($event)"
                              (keyup)="inputHelper.fixDigits($event.target)"
                            />
                          </div>
                        </div>
                      </div>
                      <div *ngIf="access.pricingGroup3" class="ui-grid-row">
                        <div class="ui-g-12 ui-sm-12">
                          <div class="ui-grid-col-8">
                            <label>London Premium (£)</label>
                          </div>
                          <div class="ui-grid-col-4">
                            <input
                              [readonly]="access.pricingGroup3 == AccessReadOnly"
                              pInputText
                              id="pricingLondonPremium"
                              formControlName="pricingLondonPremium"
                              maxlength="6"
                              (keydown)="inputHelper.allowNumberInputKey($event)"
                              (keyup)="inputHelper.fixDigits($event.target)"
                            />
                          </div>
                        </div>
                      </div>

                      <div *ngIf="access.pricingGroup3" class="ui-grid-row">
                        <div class="ui-g-12 ui-sm-12">
                          <div class="ui-grid-col-8">
                            <label>Supplier Buy It Now (%)</label>
                          </div>
                          <div class="ui-grid-col-4">
                            <input
                              [readonly]="access.pricingGroup3 == AccessReadOnly"
                              pInputText
                              id="supplierPricing_BuyItNowPrice"
                              formControlName="supplierPricing_BuyItNowPrice"
                              maxlength="4"
                              (keydown)="inputHelper.allowNumberInputKey($event)"
                              (keyup)="inputHelper.fixDigits($event.target)"
                            />
                          </div>
                        </div>
                      </div>
                      <!-- supplier transported buy it now % -->
                      <div *ngIf="access.pricingGroup3" class="ui-grid-row">
                        <div class="ui-g-12 ui-sm-12">
                          <div class="ui-grid-col-8">
                            <label>Supplier Transported Buy It Now (%)</label>
                          </div>
                          <div class="ui-grid-col-4">
                            <input
                              [readonly]="access.pricingGroup3 == AccessReadOnly"
                              pInputText
                              id="supplierPricing_TransportedBuyItNowPrice"
                              formControlName="supplierPricing_TransportedBuyItNowPrice"
                              maxlength="4"
                              (keydown)="inputHelper.allowNumberInputKey($event)"
                              (keyup)="inputHelper.fixDigits($event.target)"
                            />
                          </div>
                        </div>
                      </div>
                      <!-- end -->
                      <div *ngIf="access.pricingGroup3" class="ui-grid-row">
                        <div class="ui-g-12 ui-sm-12">
                          <div class="ui-grid-col-8">
                            <label>Supplier Buy It Now Combine (%)</label>
                          </div>
                          <div class="ui-grid-col-4">
                            <input
                              [readonly]="access.pricingGroup3 == AccessReadOnly"
                              pInputText
                              id="supplierPricing_BuyItNowPrice_Autocombine"
                              formControlName="supplierPricing_BuyItNowPrice_Autocombine"
                              maxlength="4"
                              (keydown)="inputHelper.allowNumberInputKey($event)"
                              (keyup)="inputHelper.fixDigits($event.target)"
                            />
                          </div>
                        </div>
                      </div>
                      <!--orgTypeId == 1 for VME-->
                      <div *ngIf="access.pricingGroup2 && orgTypeId == 1" class="ui-grid-row">
                        <div class="ui-g-12 ui-sm-12">
                          <div class="ui-grid-col-8">
                            <label>Margin on Additional Costs (%)</label>
                          </div>
                          <div class="ui-grid-col-4">
                            <input
                              [readonly]="access.pricingGroup2 == AccessReadOnly"
                              pInputText
                              id="pricingMargin"
                              formControlName="pricingMargin"
                              maxlength="2"
                              (keydown)="inputHelper.allowNumberInputKey($event, false)"
                              (keyup)="inputHelper.fixDigits($event.target)"
                            />
                          </div>
                        </div>
                      </div>
                      <div *ngIf="access.pricingGroup2 && orgTypeId == 1" class="ui-grid-row">
                        <div class="ui-g-12 ui-sm-12">
                          <div class="ui-grid-col-8">
                            <label>Waiting Time Threshold</label>
                          </div>
                          <div class="ui-grid-col-4">
                            <input
                              [readonly]="access.pricingGroup2 == AccessReadOnly"
                              pInputText
                              id="waitingTimeThreshold"
                              formControlName="waitingTimeThreshold"
                              maxlength="3"
                              (keydown)="inputHelper.allowNumberInputKey($event, false)"
                              (keyup)="inputHelper.fixDigits($event.target)"
                            />
                          </div>
                        </div>
                      </div>
                      <div *ngIf="access.pricingGroup2 && orgTypeId == 1" class="ui-grid-row">
                        <div class="ui-g-12 ui-sm-12">
                          <div class="ui-grid-col-8">
                            <label>Charging Time Threshold</label>
                          </div>
                          <div class="ui-grid-col-4">
                            <input
                              [readonly]="access.pricingGroup2 == AccessReadOnly"
                              pInputText
                              id="chargingTimeThreshold"
                              formControlName="chargingTimeThreshold"
                              maxlength="3"
                              (keydown)="inputHelper.allowNumberInputKey($event, false)"
                              (keyup)="inputHelper.fixDigits($event.target)"
                            />
                          </div>
                        </div>
                      </div>
                      <div *ngIf="access.pricingGroup2 && orgTypeId == 1" class="ui-grid-row">
                        <div class="ui-g-12 ui-sm-12">
                          <div class="ui-grid-col-8">
                            <label>Cleaning Service Fee</label>
                          </div>
                          <div class="ui-grid-col-4">
                            <input
                              [readonly]="access.pricingGroup2 == AccessReadOnly"
                              pInputText
                              id="cleaningServiceFee"
                              formControlName="cleaningServiceFee"
                              maxlength="5"
                              (keydown)="inputHelper.allowNumberInputKey($event, false)"
                              (keyup)="inputHelper.fixDigits($event.target)"
                            />
                          </div>
                        </div>
                      </div>
                      <div *ngIf="access.pricingGroup2 && orgTypeId == 1" class="ui-grid-row">
                        <div class="ui-g-12 ui-sm-12">
                          <div class="ui-grid-col-8">
                            <label>Urgent Special Days</label>
                          </div>
                          <div class="ui-grid-col-4">
                            <p-checkbox
                              [readonly]="access.pricingGroup2 == AccessReadOnly"
                              id="urgentSpecialDays"
                              formControlName="urgentSpecialDays"
                              maxlength="5"
                              binary="true"
                            ></p-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="ui-md-7 ui-g-12"
                      *ngIf="
                        reqAgreementType == agreementType.GenericCustomerTerms ||
                        reqAgreementType == agreementType.BespokeCustomer
                      "
                    >
                      <app-service-fee-type
                        [isReadonly]="!access.isPricingAdmin"
                        *ngIf="orgTypeId == 1"
                      ></app-service-fee-type>
                      <br />
                      <br />
                      <app-customer-service-fee
                        [isReadonly]="!access.isPricingAdmin"
                        *ngIf="reqAppliedOrgId"
                        [customerId]="reqAppliedOrgId"
                        [customerName]="orgName"
                      ></app-customer-service-fee>

                      <app-customer-service-fee
                        [isReadonly]="!access.isPricingAdmin"
                        *ngIf="!reqAppliedOrgId"
                        [customerName]="'All Customers'"
                      ></app-customer-service-fee>
                    </div>
                  </div>
                </div>

                <div *ngIf="access.discounts" style="">
                  <div class="ui-grid-row">
                    <div class="ui-g-12">
                      <h2 class="sub-header-bar mb-1">Combined Job Discounts</h2>
                    </div>
                  </div>

                  <div class="card">
                    <div class="ui-grid-row">
                      <div class="ui-g-12 ui-sm-12">
                        <div class="ui-grid-col-5">
                          <label>Number of Vehicles</label>
                        </div>
                        <div class="ui-grid-col-7">
                          <label>% Discount</label>
                        </div>
                      </div>
                    </div>

                    <div class="ui-grid-row">
                      <div class="ui-g-12 ui-sm-12">
                        <div class="ui-grid-col-5">
                          <label>2</label>
                        </div>
                        <div class="ui-grid-col-7">
                          <input
                            [readonly]="access.discounts == AccessReadOnly"
                            pInputText
                            id="discount2Vehicles"
                            formControlName="discount2Vehicles"
                            maxlength="2"
                            (keydown)="inputHelper.allowNumberInputKey($event, false)"
                            (keyup)="inputHelper.fixDigits($event.target)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="ui-grid-row">
                      <div class="ui-g-12 ui-sm-12">
                        <div class="ui-grid-col-5">
                          <label>3</label>
                        </div>
                        <div class="ui-grid-col-7">
                          <input
                            [readonly]="access.discounts == AccessReadOnly"
                            pInputText
                            id="discount3Vehicles"
                            formControlName="discount3Vehicles"
                            maxlength="2"
                            (keydown)="inputHelper.allowNumberInputKey($event, false)"
                            (keyup)="inputHelper.fixDigits($event.target)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="ui-grid-row">
                      <div class="ui-g-12 ui-sm-12">
                        <div class="ui-grid-col-5">
                          <label>4</label>
                        </div>
                        <div class="ui-grid-col-7">
                          <input
                            [readonly]="access.discounts == AccessReadOnly"
                            pInputText
                            id="discount4Vehicles"
                            formControlName="discount4Vehicles"
                            maxlength="2"
                            (keydown)="inputHelper.allowNumberInputKey($event, false)"
                            (keyup)="inputHelper.fixDigits($event.target)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="ui-grid-row">
                      <div class="ui-g-12 ui-sm-12">
                        <div class="ui-grid-col-5">
                          <label>5</label>
                        </div>
                        <div class="ui-grid-col-7">
                          <input
                            [readonly]="access.discounts == AccessReadOnly"
                            pInputText
                            id="discount5Vehicles"
                            formControlName="discount5Vehicles"
                            maxlength="2"
                            (keydown)="inputHelper.allowNumberInputKey($event, false)"
                            (keyup)="inputHelper.fixDigits($event.target)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="ui-grid-row">
                      <div class="ui-g-12 ui-sm-12">
                        <div class="ui-grid-col-5">
                          <label>6</label>
                        </div>
                        <div class="ui-grid-col-7">
                          <input
                            [readonly]="access.discounts == AccessReadOnly"
                            pInputText
                            id="discount6Vehicles"
                            formControlName="discount6Vehicles"
                            maxlength="2"
                            (keydown)="inputHelper.allowNumberInputKey($event, false)"
                            (keyup)="inputHelper.fixDigits($event.target)"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="ui-grid-row">
                      <div class="ui-g-12 ui-sm-12">
                        <div class="ui-grid-col-5">
                          <label>7</label>
                        </div>
                        <div class="ui-grid-col-7">
                          <input
                            [readonly]="access.discounts == AccessReadOnly"
                            pInputText
                            id="discount7Vehicles"
                            formControlName="discount7Vehicles"
                            maxlength="2"
                            (keydown)="inputHelper.allowNumberInputKey($event, false)"
                            (keyup)="inputHelper.fixDigits($event.target)"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="ui-grid-row">
                      <div class="ui-g-12 ui-sm-12">
                        <div class="ui-grid-col-5">
                          <label>Return journey discount (%)</label>
                        </div>
                        <div class="ui-grid-col-7">
                          <input
                            [readonly]="access.discounts == AccessReadOnly"
                            pInputText
                            id="discountReturn"
                            formControlName="discountReturn"
                            maxlength="2"
                            (keydown)="inputHelper.allowNumberInputKey($event, false)"
                            (keyup)="inputHelper.fixDigits($event.target)"
                          />
                        </div>
                      </div>
                    </div>

                    <div *ngIf="access.pricingGroup2 && orgTypeId == 1" class="ui-grid-row">
                      <div class="ui-g-6 ui-sm-12">
                        <div class="ui-grid-col-8">
                          <label>Markup Invoice Percentage</label>
                        </div>
                        <div class="ui-grid-col-4">
                          <input
                            [readonly]="access.pricingGroup2 == AccessReadOnly"
                            pInputText
                            id="markupPercentage"
                            formControlName="markupPercentage"
                            maxlength="2"
                            (keydown)="inputHelper.allowNumberInputKey($event, false)"
                            (keyup)="inputHelper.fixDigits($event.target)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style=""
              *ngIf="
                this.agreementData &&
                (reqAgreementType == agreementType.BespokeCustomer ||
                  reqAgreementType == agreementType.GenericCustomerTerms ||
                  reqAgreementType == agreementType.GenericCustomer)
              "
            >
              <div class="ui-grid-row">
                <div class="ui-g-12">
                  <manage-timeband-premiums
                    [isReadonly]="!access.isPricingAdmin"
                    [customerId]="reqAppliedOrgId"
                  ></manage-timeband-premiums>
                </div>
              </div>
            </div>

            <!--<div *ngIf="access.urgentJobs" style="margin-top:20px">
                <div class="ui-grid-row">
                    <div class="ui-g-12">
                        <h2>Urgent Jobs</h2>
                    </div>
                </div>

                <div class="ui-grid-row">
                    <div class="ui-g-8">
                        <div class="ui-grid-col-12">
                            Job is not urgent if it is booked before
                            <p-calendar [disabled]="access.urgentJobs==AccessReadOnly" [class.access-disabled]="access.urgentJobs==AccessReadOnly" class="urgent-jobs-calendar"
                                        formControlName="urgentBookBefore" [timeOnly]="true"></p-calendar>
                            on the day if the job and starts after
                            <p-calendar [disabled]="access.urgentJobs==AccessReadOnly" [class.access-disabled]="access.urgentJobs==AccessReadOnly"
                                        class="urgent-jobs-calendar" formControlName="urgentStartAfter" [timeOnly]="true"></p-calendar>
                            on the following day
                        </div>
                    </div>
                </div>
            </div>-->
          </div>
          <div style=""></div>
        </p-tabPanel>

        <p-tabPanel *ngIf="access.rateCard" header="Rate Card Pricing Matrix">
          <div class="ui-grid-row">
            <!--don't need in this phase-->
            <div class="ui-g-12">
              <div class="ui-grid-col-2">
                <p-checkbox
                  [disabled]="!access.isPricingAdmin"
                  label="Price banding required"
                  name="usePriceBanding"
                  formControlName="usePriceBanding"
                  (onChange)="onUsePriceBandingChange($event)"
                  binary="true"
                ></p-checkbox>
              </div>
            </div>
          </div>

          <!-- rate-card preset selection -->
          <preset-rate-card-selector
            *ngIf="
              isNetworkAssuranceAdmin &&
              access.isPricingAdmin &&
              (reqAgreementType == agreementType.BespokeCustomer ||
                reqAgreementType == agreementType.BespokeSupplier)
            "
            (presetSelected)="onPresetSelected($event)"
          ></preset-rate-card-selector>
          <!-- End of rate-card preset selection -->

          <div
            class="ui-grid-row"
            *ngIf="agreement.usePriceBanding.value"
            style="margin-bottom: 20px; margin-top: 20px"
          >
            <div class="ui-g-12">
              <h2 class="sub-header-bar">Bandings</h2>
              <p-table
                #dtAgreementBandings
                [value]="bandings"
                [(selection)]="selectedBanding"
                [lazy]="false"
                [paginator]="false"
                [style]="{ width: '300px' }"
                [class.no-zebra-shading]="true"
                [responsive]="true"
              >
                <!--
                (onEditInit)="bandingEditInit($event)"
                (onEditComplete)="bandingEditComplete($event)"
                (onEditCancel)="bandingEditCancel($event)"
                -->

                <ng-template pTemplate="header">
                  <tr>
                    <th>Lower Threshold (Miles)</th>
                    <th></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-band let-index="rowIndex">
                  <tr>
                    <td>
                      <span>{{ band.from }}</span>
                    </td>
                    <td>
                      <div class="flex w-100 justify-content-around">
                        <i
                          class="fa ui-icon-edit"
                          (click)="editBanding(band)"
                          *ngIf="index > 0"
                        ></i>
                        <i
                          class="fa ui-icon-clear"
                          (click)="deleteBanding(band)"
                          *ngIf="index == bandings.length - 1 && index != 0"
                        ></i>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>

              <div class="footerPanel">
                <button
                  type="button"
                  pButton
                  icon="fa ui-icon-add"
                  (click)="addBanding()"
                  label="Add"
                ></button>
              </div>
            </div>
          </div>

          <div class="ui-grid-row" *ngIf="rateGridData">
            <div class="ui-g-12">
              <div class="w-full flex justify-content-between">
                <h2 class="sub-header-bar">
                  Services Provided
                  <span
                    style="margin-left: 8px; font-size: 0.8rem; font-weight: bold"
                    *ngIf="agreementData?.ratecardPreset && !selectedRateCardPresetId"
                  >
                    ({{ agreementData.ratecardPreset.presetName }} Rate Card Preset)</span
                  >
                  <span
                    style="margin-left: 8px; font-size: 0.8rem; font-weight: bold"
                    *ngIf="selectedRateCardPresetId"
                  >
                    ({{ selectedRatecardPresetName }} Rate Card Preset)</span
                  >
                </h2>
                <div class="flex font-bold">
                  <p-checkbox
                    binary="true"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="showOfferedServicesOnly"
                  ></p-checkbox>
                  <div class="ml-2">Show Offered Only</div>
                </div>
              </div>

              <p-accordion
                [multiple]="true"
                [class.rate-card-accordion]="true"
                *ngIf="
                  srvGridChecked[0] || srvGridChecked[1] || srvGridChecked[2] || srvGridChecked[3];
                  else noServices
                "
              >
                <p-accordionTab header="Driven" [selected]="true" *ngIf="srvGridChecked[0]">
                  <p-tabView>
                    <p-tabPanel header="Standard Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[0][0]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                    <p-tabPanel header="Urgency Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[0][2]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>

                    <p-tabPanel header="Standard Postcode Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[0][3]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [isPostcodeBased]="true"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                    <p-tabPanel header="Urgency Postcode Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[0][5]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [isPostcodeBased]="true"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                  </p-tabView>
                </p-accordionTab>

                <p-accordionTab
                  header="Transported"
                  [selected]="isTransporter()"
                  *ngIf="srvGridChecked[1]"
                >
                  <p-tabView>
                    <p-tabPanel header="Standard Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[1][0]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                    <p-tabPanel header="Urgency Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[1][2]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>

                    <p-tabPanel header="Standard Postcode Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[1][3]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [isPostcodeBased]="true"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                    <p-tabPanel header="Urgency Postcode Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[1][5]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [isPostcodeBased]="true"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                  </p-tabView>
                </p-accordionTab>
                <!--
                *ngIf="srvGridChecked[3]"
                -->
                <p-accordionTab
                  header="Recovery"
                  [selected]="isRecoverer()"
                  *ngIf="srvGridChecked[2]"
                >
                  <p-tabView>
                    <p-tabPanel header="Standard Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[2][0]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                    <p-tabPanel header="Out of Hours Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[2][1]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>

                    <p-tabPanel header="Standard Postcode Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[2][3]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [isPostcodeBased]="true"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                    <p-tabPanel header="Out of Hours Postcode Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[2][4]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [isPostcodeBased]="true"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                  </p-tabView>
                </p-accordionTab>
                <p-accordionTab header="Inspection">
                  <p-tabView>
                    <p-tabPanel header="Standard Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[3][0]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                    <p-tabPanel header="Urgency Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[3][2]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>

                    <p-tabPanel header="Standard Postcode Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[3][3]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [isPostcodeBased]="true"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                    <p-tabPanel header="Urgency Postcode Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[3][5]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [isPostcodeBased]="true"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                  </p-tabView>
                </p-accordionTab>
                <p-accordionTab header="Inspect & Collect">
                  <p-tabView>
                    <p-tabPanel header="Standard Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[4][0]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                    <p-tabPanel header="Urgency Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[4][2]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>

                    <p-tabPanel header="Standard Postcode Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[4][3]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [isPostcodeBased]="true"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                    <p-tabPanel header="Urgency Postcode Pricing">
                      <rate-card-grid
                        [datas]="rateGridData[4][5]"
                        [useBanding]="agreement.usePriceBanding.value"
                        [agreementBandings]="bandings"
                        [pricesReadonly]="access.rateCard != AccessEditable"
                        [isPostcodeBased]="true"
                        [showOfferedServicesOnly]="showOfferedServicesOnly"
                        [inclusivityTypes]="inclusivityTypes"
                      >
                      </rate-card-grid>
                    </p-tabPanel>
                  </p-tabView>
                </p-accordionTab>
              </p-accordion>
              <ng-template #noServices>No services have been selected</ng-template>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
      <div class="content-container py-0">
        <div class="flex">
          <div class="flex-grow-1 p-2">
            <p-checkbox
              *ngIf="access.agree"
              formControlName="isAgreed"
              name="isAgreed"
              binary="true"
              label="I agree to these details"
            ></p-checkbox>
          </div>
          <div class="flex-shrink-1 p-2">
            <button
              type="button"
              icon="fa ui-icon-check"
              (click)="save(agreementForm.value)"
              class="green-btn"
              style="float: right"
              pButton
              label="Save"
              [disabled]="agreementForm.invalid || !access.isPricingAdmin"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div
    style="
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: gray;
      opacity: 0.3;
    "
    *ngIf="isBusy"
  >
    <img
      src="assets/images/loader.gif"
      style="margin-left: 45%; margin-top: 20%"
      width="50"
      height="50"
      alt="load"
    />
  </div>
</div>

<p-dialog
  header="New Band"
  [(visible)]="bandingDialogVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '300px' }"
>
  <form>
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-grid-row">
        <div class="ui-g-8"><label for="dlgBandingFrom">Lower Threshold</label></div>
        <div class="ui-g-4">
          <p-spinner
            [size]="8"
            class="inline-grid-number"
            name="dlgBandingFrom"
            [max]="10000"
            [min]="0"
            [step]="1"
            [(ngModel)]="dlgBanding.from"
            [maxlength]="6"
            [formatInput]="false"
          ></p-spinner>
        </div>
      </div>
      <div class="ui-grid-row" *ngIf="!bandingValid(dlgBanding)[0]">
        <div class="ui-g-12">{{ bandingValid(dlgBanding)[1] }}</div>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-grid-row" style="float: right">
      <button
        type="button"
        class="green-btn"
        pButton
        icon="fa ui-icon-check"
        (click)="dlgSaveBanding()"
        label="Save"
        [disabled]="!bandingValid(dlgBanding)[0]"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Close"
        (click)="bandingDialogVisible = false"
      ></button>
    </div>
  </form>
</p-dialog>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Save"
  rejectLabel="Cancel"
></p-confirmDialog>

<ng-template #loading>Loading...</ng-template>
